import {Ttm} from './ttm';
import {User} from './user';
import {Geometry} from '@turf/helpers';
import {TtmStatus} from './ttmstatus';

export class TtmImage {
    id: number;
    ttm_id: number;
    ttm_status_key: string;
    ttm?: Ttm;
    status?: TtmStatus;
    user: User;
    user_id: number;
    location?: Geometry;
    heading?: number;

    updated_at: Date;
    created_at: Date;
}
